import { Component, OnInit, AfterContentInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore, QueryFn } from '@angular/fire/compat/firestore';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';
import { GovServiceService } from 'src/app/service/gov-service.service';
import printJS from 'print-js';


type ServiceCategory = 'Internal Service' | 'External Service';

type GroupedServices = {
  [key in ServiceCategory]: Record<string, any[]>;
};
@Component({
  selector: 'app-artemis-citizens-charter-view',
  templateUrl: './artemis-citizens-charter-view.component.html',
  styleUrls: ['./artemis-citizens-charter-view.component.scss']
})
export class ArtemisCitizensCharterViewComponent implements OnInit {
  @Input() loader: boolean;
  @Input() cc_id: any;
  @Input() agency_id: any;
  @Input() link: any;
  @Input() submissionOnly: boolean = false
  @Output() changeDetect: EventEmitter<any> = new EventEmitter()
  @Output() loaderChange: EventEmitter<boolean> = new EventEmitter()
  @Output() ccIdChange: EventEmitter<any> = new EventEmitter()
  @Output() currentCCChange: EventEmitter<any> = new EventEmitter()
  @Output() currentAgencyChange: EventEmitter<any> = new EventEmitter()
  @Output() servicesChange: EventEmitter<any> = new EventEmitter()
  @Output() cartChange: EventEmitter<any> = new EventEmitter()

  // loader:boolean = false;

  currentCC: any;
  currentCCReportURL: any;
  agencies: any[] = []
  agencyName: any;
  currentAgency: any;
  headOfAgency: any[] = [];
  chairPerson: any[] = [];
  viceChairPerson: any[] = [];
  member: any[] = [];
  services: any[] = []
  countStepwithFormula: number = 0;
  countStepwithPossible: number = 0;



  ordinals: string[] = ['th', 'st', 'nd', 'rd'];

  constructor(
    private afs: AngularFirestore,
    public auth: AngularFireAuth,
    private _service: GovServiceService,
    private sanitizer: DomSanitizer
  ) { }

  /* get InternalServices() {
    return this.services.filter(filter => filter.serviceDetails.service_category == "Internal Service")
  }

  get ExternalServices() {
    return this.services.filter(filter => filter.serviceDetails.service_category == "External Service")
  }

  
  get ExternalServiceProcessOwners() {
 
    const externalServices = this.InternalServices

   
    const processOwners = externalServices.map(service => service.serviceDetails.process_owner);
    const uniqueProcessOwners = Array.from(new Set(processOwners));

    uniqueProcessOwners.sort((a, b) => a.localeCompare(b));

    return uniqueProcessOwners;
  }

  get InternalServiceProcessOwners() {
 
    const externalServices = this.services.filter(service => service.serviceDetails.service_category === "Internal Service");

    
    const processOwners = externalServices.map(service => service.serviceDetails.process_owner);
    const uniqueProcessOwners = Array.from(new Set(processOwners));

    uniqueProcessOwners.sort((a, b) => a.localeCompare(b));

    return uniqueProcessOwners;
  } */

  ngOnInit(): void {
    //console.log('CharterReportsComponent 2')
    this.loader = true;
    // this.loaderChangeEmitter()
    this.changeEmitter('loader', this.loader)
    if (!this.currentCC || this.submissionOnly) {
      if (this.cc_id && !this.agency_id) {
        this.loadCC(this.cc_id)
      }
      else if (this.agency_id && !this.cc_id) {
        this.loadCCbyAgency(this.agency_id)
      }
    }
  }

  groupedServices!: GroupedServices;

  categorizeAndGroup(services: any = []): GroupedServices {
    const result: GroupedServices = {
      'Internal Service': {},
      'External Service': {},
    };

    for (const service of services) {
      const category = service.serviceDetails.service_category as ServiceCategory; // Safe cast
      const owner = service.serviceDetails.process_owner;

      // This is now safe because category is explicitly ServiceCategory
      if (!result[category][owner]) {
        result[category][owner] = [];
      }

      result[category][owner].push(service);
    }

    return result;
  }

  private loadCC(cc_id: any) {
    // console.log('loadCC: '+cc_id)
    let sub1 = this.afs.collection('citizens-charter-phase-02').doc(cc_id)
      .snapshotChanges()
      .pipe(first())
      .subscribe(info => {
        if (info.payload.exists) {
          let charter: any = info.payload.data()
          charter.id = info.payload.id
          this.currentCCReportURL = charter?.reportURL
          this.currentCC = charter

          if (charter.fromAgencyId) this.loadAgencyById(charter.fromAgencyId)

          this.loadedCC(charter)
          //  this.currentCCChangeEmitter()
          this.changeEmitter('currentCC', charter)
        }
        sub1.unsubscribe()
      })

    /*  let sub2 = this.afs.collection('citizens-charter-phase-02').doc(cc_id)
       .snapshotChanges()
       .pipe(first())
       .subscribe(info => {
         if (info.payload.exists) {
           let charter: any = info.payload.data()
           charter.id = info.payload.id
           this.currentCC = charter
           this.currentCCReportURL = charter.reportURL
           if (charter.fromAgencyId) this.loadAgencyById(charter.fromAgencyId)
 
           this.loadedCC(charter)
         }
         sub2.unsubscribe()
       }) */
  }

  private loadAgencyById(agencyId: any) {
    // console.log('loadAgencyById: '+agencyId)
    let sub1 = this.afs.collection('Agency').doc(agencyId).snapshotChanges()
      .subscribe({
        next: (result) => {
          if (result) {
            if (result.payload.exists) {
              let agency: any = result.payload.data()
              agency.id = result.payload.id
              this.loadedAgency(agency)
            }
          }
          sub1.unsubscribe()
        },
        error: (err) => {
          // console.error('Error: ',err)
          sub1.unsubscribe()
        }
      })
  }

  private loadedAgency(agency: any) {
    // console.log('loadedAgency: '+agency)
    this.currentAgency = agency
    // this.currentAgencyChangeEmitter()
    this.changeEmitter('currentAgency', agency)
  }

  private loadCCbyAgency(agency_id: any) {
    // console.log('loadCCbyAgency: '+agency_id)
    if (agency_id) this.loadAgencyById(agency_id)

    let sub1 = this.afs.collection('citizens-charter-phase-02', filter => filter.where("fromAgencyId", "==", agency_id).orderBy("date_posted", 'desc').limit(1))
      .snapshotChanges()
      .subscribe({
        next: (resultArr) => {
          resultArr.map((info) => {
            if (info.payload.doc.exists) {
              let charter: any = info.payload.doc.data()
              charter.id = info.payload.doc.id
              this.cc_id = charter.id
              // this.ccIdChangeEmitter()
              this.changeEmitter('ccId', charter.id)
              this.loadedCC(charter)
            }
          })
          sub1.unsubscribe()
        },
        error: (err) => {
          // console.error('Error: ',err)
          sub1.unsubscribe()
        }
      })
  }

  private loadedCC(charter: any) {
    // console.log('loadedCC: ',charter)
    if (charter.fromAgencyName) this.agencyName = charter.fromAgencyName

    if (charter.service_id) this.loadServices(charter.service_id)

    if (charter.committee) {
      if (charter.committee.head_of_agency) this.headOfAgency = charter.committee.head_of_agency
      if (charter.committee.chairperson) this.chairPerson = charter.committee.chairperson
      if (charter.committee.vice_chairperson) this.viceChairPerson = charter.committee.vice_chairperson
      if (charter.committee.members) this.member = charter.committee.members
    }


    const cart = {
      headOfAgency: this.headOfAgency,
      chairPerson: this.chairPerson,
      viceChairPerson: this.viceChairPerson,
      member: this.member
    }
    this.changeEmitter('cart', cart)
    this.currentCC = charter
    this.changeEmitter('currentCC', charter)
    this.loader = false
    this.changeEmitter('loader', this.loader)
    //console.log('charter: ',charter)
  }

   @ViewChild('printSection') printSection!: ElementRef;
    
  print() {
    this.printing=true;
      printJS({
        printable: this.printSection.nativeElement,
        type: 'html',
        css: [
          // adjust path if you have a base href or prefix
          `${window.location.origin}/styles.scss`,
        ],
        scanStyles: false ,  
        style:`
            .page-break {
              page-break-before: always;
              break-before: page;
            }

            .front-page{
              padding-top: 12em;
            }

            .agency-name{
              font-size: 40px;
              text-align:center
            }
 
            .cc-edition{
              font-size: 20px;
              padding-top: 10em;
              text-transform: uppercase;
              font-weight: bold;
              text-align:center;  
            }

            .example-spacer {
              flex: 1 1 auto;
            }

            .my-image {
              display: block;      /* make it a block-level element */
              margin: 0 auto;      /* auto left/right margins center it */
              /* optional: constrain width */
              max-width: 100%;
              height: auto;
            }
  
            @import '~mdb-ui-kit/css/mdb.min.css';
              /* Make the clone only as wide as a normal sheet of paper */
              #print-sections {
                width: 100% !important;
                box-sizing: border-box !important;
              }

            /* Ensure your tables fill that container, but don’t overflow it */
            #print-sections table {
              width: 100% !important;
              table-layout: auto !important;
            }

              * {
              -webkit-print-color-adjust: exact !important;  /* Chrome, Safari */
              print-color-adjust: exact !important;          /* Firefox */
            }

            .justify-content-center{
              justify-content: center;
            }

          

            * {
              font-family: Heebo, Arial, Helvetica, sans-serif;
              scroll-behavior: smooth;
            }

            .step {
              vertical-align: top;
            }

            .example-full-width {
              width: 100%;
            }

            .header{
              font-weight: bold;
              text-align: center;
            }

            .text-header{
              font-size: 14px;
              font-weight: bold;
            }

            .text-content{
              font-size: 12px;
            }

            .cart-table{
              
              th, td{
                text-align: left;
                font-size: 12px;
              }

            }

            .service-list{
              font-size: 12px;
              text-align: left;
            }

            .service-details {
              width: 100%;
              table-layout: fixed;
              font-size: 12px;
              text-align: left;
            }

            .service-details th,
            .service-details td {
              border: 1px solid black;
              border-collapse: collapse;
              padding: 0.5em 0.5em;
            }

            .service-details tbody {
              width: inherit;
            }

            .srvc-name {font-size:14px; }
            
            .srvc-desc{font-size:12px; text-indent: 0.5em;}

            .service-details tbody tr {
              width: inherit;
            }

            .service-details tbody tr th {
              background-color: rgb(21, 143, 199);
              font-weight: bold;
            }

            .service-details tbody tr .row-header {
              font-weight: bold;
            }


.content-center {
  display: flex;
  justify-content: center;
}

.subrequirement-table td {
  padding-left: 1rem;
}

.requirement-table,
.subsit-table,
.subrequirement-table {
  width: 100%;
}

.requirement-table th,
.requirement-table td,
.subsit-table th,
.subsit-table td,
.subrequirement-table th,
.subrequirement-table td {
  border: none;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  vertical-align: top;
}

/* Visual Hierarchy for Levels */
.depth-1 td {
  padding-left: 0.75rem;
}

.depth-2 td {
  padding-left: 2rem;
}

.depth-3 td {
  padding-left: 3rem;
}

.depth-4 td {
  padding-left: 4.5rem;
  font-style: italic;
  opacity: 0.95;
}

/* Optional: Different font styles per depth */
.depth-1 td span,
.depth-1 td b {
  font-weight: bold;
}

.depth-2 td span,
.depth-2 td b {
  font-weight: 600;
}

.depth-3 td span,
.depth-3 td b {
  font-weight: normal;
  font-style: italic;
}

/* Main Section Header */
.section-header {
  font-weight: bold;
  padding: 0.5rem 1rem;
  background-color: #a1d7fd;
  border-left: 4px solid #2196f3;
}

/* Subsection Header */
.subsection-header {
  font-style: italic;
  font-weight: 600;
  padding: 0.5rem 1rem;
  background-color: #aed6ff;
  border-left: 4px solid #89c9fd;
}

/* Subsection Highlight Wrapper */
.subsection-highlight {
  background-color: rgb(221, 221, 221);
  padding: 0.25rem 1rem;
  border-left: 3px solid #8f8f8f;
  font-style: italic;
  font-weight: 600;
}
table {
  /* collapse all table borders into one */
  border-collapse: collapse !important;
  /* remove any spacing between cells */
  border-spacing: 0 !important;
  /* kill any default top/bottom margin on the table itself */
  margin: 0 !important;
}
.middle-row-bot-border {
  border-bottom: 0.3px solid rgb(116, 116, 116);
}

.step_loc {
  overflow-wrap: break-word;
}

.step_notes {
  overflow-wrap: break-word;
  font-style: italic;
}
.wrapper{
  li
  {
  overflow-wrap: break-word;
  margin-left: 1px;
  padding-left: 0.5px;
  }
 } 

.page-cover {
  display: flex;
  justify-content: center;   /* horizontal center */
  align-items: center;       /* vertical center */
  height: 100vh;             /* full height of printable page */
  page-break-after: always;  /* force page break after this */
}

.xtnl-srvc {
  margin: 0; /* remove top/bottom margins for vertical centering */
  text-align: center;
}

.my-tooltip {
  white-space: pre-line;
}

.mce-content-body table {
  border-collapse: collapse;
  width: 100%;
}



.mce-content-body th,
.mce-content-body td {
  border: 1px solid #000;
  padding: 5px;
}

 
      
    `
     
      });
      setTimeout(() => {
        this.printing=false
      }, 10);
    }

    printing:boolean=false

  sanitizeHTML(input: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(input);
  }

  serviceloading: boolean = false

  private async loadServices(service_ids: any[]) {
    this.countStepwithFormula = 0;
    this.countStepwithPossible = 0;

    let inboxFilter: QueryFn;
    if (!this.submissionOnly) {
      inboxFilter = (filter) => filter.where('is_posted', '==', true);
    }

    this.changeEmitter('serviceloading', true);

    const servicePromises = service_ids.map(id =>
      firstValueFrom(
        this.afs.collection('Services Phase 02', inboxFilter).doc(id).snapshotChanges()
      ).then(info => {
        if (info.payload.exists) {
          let service: any = info.payload.data();
          service.id = info.payload.id;

          // Preprocess requirements
          if (service.standardRequirements)
            service.standardRequirements = this.preProcessStandardReq(service.standardRequirements);

          if (service?.situationalRequirementsArray) {
            const temp_sit = service.situationalRequirementsArray;
            service.situationalRequirementsArray = [];
            temp_sit.forEach((situation: any) => {
              service.situationalRequirementsArray.push({
                title: situation.title,
                requirement: this.preProcessStandardReq(situation.requirement),
                subRequirement: this.preprocessSubSituationalReq(situation.subRequirement || [])
              });
            });
          }

          // Transaction type string
          if (service.serviceDetails.type_of_transaction) {
            let t = service.serviceDetails.type_of_transaction;
            let transactionTypeString = '';
            if (t.type_g2b) transactionTypeString += 'G2B (Government to Business)';
            if (t.type_g2c) transactionTypeString += (transactionTypeString ? ', ' : '') + 'G2C (Government to Citizen)';
            if (t.type_g2g) transactionTypeString += (transactionTypeString ? ', ' : '') + 'G2G (Government to Government)';
            service.serviceDetails.transactionTypeString = transactionTypeString;
          }

          // Operating time
          if (service.serviceDetails.operating_hours) {
            let time = service.serviceDetails.operating_hours;
            const parts = time.split('-');
            if (parts.length === 2) {
              const start = parts[0].split(':')[0]?.trim();
              const end = parts[1].split(':')[0]?.trim();
              service.serviceDetails.operatingTime = `${start}:00 AM - ${end}:00 PM`;
            } else {
              service.serviceDetails.operatingTime = time;
            }
          }

          // Client steps
          if (service.clientSteps)
            service.processedClientStep = this._service.processClientStep(service.clientSteps);

          service.countStepwithFormula = this.countStepwithFormula;
          service.countStepwithPossible = this.countStepwithPossible;

          // Only push if posted or submissionOnly
          if (service.is_posted === true || this.submissionOnly) {
            return service;
          }
        }

        return null; // not found or not eligible
      })
    );

    // Wait for all service promises to resolve
    const results = await Promise.all(servicePromises)



    // Filter nulls and prevent duplicates
    this.services = results.filter(s => s && !this.services.find(x => x.id === s.id));

    // Emit once all loaded
    this.changeEmitter('services', this.services);



    // You can now safely run another function here
    this.groupedServices = this.categorizeAndGroup(this.services); // 

    this.changeEmitter('serviceloading', false);


  }

  keyword: any = ""

  transform(n: number, year: string, keepNumber: boolean = true) {
    let v = n % 100;
    return year + " " + (keepNumber ? n : '') + (this.ordinals[(v - 20) % 10] || this.ordinals[v] || this.ordinals[0]) + " Edition";
  }

  private preProcessStandardReq(standardRequirements: any) {
    if (standardRequirements && standardRequirements.length > 0) {
      standardRequirements.map((docItem: any) => {
        switch (docItem.requirementType) {
          case 'Documentary': {
            if (docItem.documentFormat && docItem.documentFormat.length > 0) {
              docItem.documentString = ''
              docItem.documentFormat.map((formatItem: any, index: any) => {
                switch (formatItem.type) {
                  case 'document': {
                    if (index > 0) docItem.documentString += ' '
                    switch (formatItem.value) {
                      case 'Original Copy': {
                        docItem.documentString += '(' + (formatItem.copyCount ? formatItem.copyCount : docItem.originalCopy ? docItem.originalCopy : 'Undefined') + ') ' + formatItem.value
                        break
                      }
                      case 'Photo Copy': {
                        docItem.documentString += '(' + (formatItem.copyCount ? formatItem.copyCount : docItem.photoCopy ? docItem.photoCopy : 'Undefined') + ') ' + formatItem.value
                        break
                      }
                      case 'Electronic Copy': {
                        docItem.documentString += '(' + (formatItem.copyCount ? formatItem.copyCount : docItem.electronicCopy ? docItem.electronicCopy : 'Undefined') + ') ' + formatItem.value
                        break
                      }
                    }
                    break;
                  }
                  case 'operator': {
                    switch (formatItem.value) {
                      case 'or': {
                        docItem.documentString += formatItem.value
                        break
                      }
                      default: {
                        if (index > 0) docItem.documentString += ' '
                        docItem.documentString += formatItem.value
                      }
                    }
                    break;
                  }
                  default: {
                    if (index > 0) docItem.documentString += ' '
                    docItem.documentString += formatItem.value
                  }
                }
              })
            }
            break;
          }
        }

      })
    }
    return standardRequirements
  }

  private preprocessSubSituationalReq(subrequirement: any) {

    let tempsubreq = []

    for (var req of subrequirement) {

      tempsubreq.push({
        title: req.title,
        requirement: this.preProcessStandardReq(req.requirement)
      })

    }

    return tempsubreq;

  }

  /*  private processClientStep(clientSteps: any[]) {
     this.countStepwithFormula = 0;
     this.countStepwithPossible = 0;
     let processedClientSteps: any = []
     if (clientSteps && clientSteps.length > 0) {
       clientSteps.map((clientStep, index) => {
         if (clientStep.info?.list_of_formula_fees_arr.length > 0) {
           this.countStepwithFormula++;
         }
         if (clientStep.info?.list_of_possible_fees_arr.length > 0) {
           this.countStepwithPossible++;
         }
         if (clientStep.agency_actions && clientStep.agency_actions.length > 0) {
 
           clientStep.agency_actions.map((agencyAction: any, index2: number) => {
             let clientStepRow = {
               clientStepName: index2 == 0 ? (index + 1) + '. ' + clientStep.info.title : '',
               agencyActions: (index + 1) + '.' + (index2 + 1) + '. ' + agencyAction.title,
               fees: index2 == 0 ? this.getClientStepFees(clientStep.info) : '',
               location: clientStep.info.location,
               processingTime: '',
               possibleFeesArr: clientStep.info.list_of_possible_fees_arr,
               formulaFeesArr: clientStep.info.list_of_formula_fees_arr,
               notes: clientStep.info.notes,
               personResponsible: agencyAction.persons_responsible,
               isSituationalStep: clientStep.info.is_situational_step,
               situation: clientStep.info.is_situational_step ? clientStep.info.situation : '',
 
               rowSpan: (clientStep.agency_actions.length > 1) ? (index2 == 0) ? clientStep.agency_actions.length : 0 : 1 
             }
 
             let processingTime = '';
 
             if (agencyAction?.calendardays) {
               const days = Number(agencyAction.processing_time_days);
               if (days && !isNaN(days) && days > 0) processingTime += agencyAction.processing_time_days + ' calendar day/s'
               
 
             } else {
 
               if (agencyAction.processing_time_days) {
                 const days = Number(agencyAction.processing_time_days);
                 if (days && !isNaN(days) && days > 0) processingTime += agencyAction.processing_time_days + ' day/s'
               }
 
               if (agencyAction.processing_time_hours) {
                 const hours = Number(agencyAction.processing_time_hours);
                 if (hours && !isNaN(hours) && hours > 0) processingTime += (processingTime ? ', ' : '') + agencyAction.processing_time_hours + ' hour/s'
               }
 
               if (agencyAction.processing_time_minutes) {
                 const mins = Number(agencyAction.processing_time_minutes);
                 if (mins && !isNaN(mins) && mins > 0) processingTime += (processingTime ? ', ' : '') + agencyAction.processing_time_minutes + ' minute/s'
               }
 
             }
 
 
             clientStepRow.processingTime = processingTime
             processedClientSteps.push(clientStepRow)
           })
         } else {
           processedClientSteps.push({
             clientStepName: clientStep.info.title,
             agencyActions: '',
             fees: this.getClientStepFees(clientStep.info),
             processingTime: '',
             personResponsible: '',
             borderBottom: true,
           })
         }
       })
       return processedClientSteps
     }
 
     return processedClientSteps
   } */

  private getClientStepFees(clientStepData: any) {
    let fees = ''
    if (clientStepData.standard_fees == true || clientStepData.list_of_possible_fees_or_formulas == true) {
      if (clientStepData.standard_fees == true) {
        fees += clientStepData.fees + ' PHP'//return clientStepData.fees+' php'
        if (clientStepData.fees_arr && clientStepData.fees_arr.length > 0) {
          fees += (fees ? '<br><br>' : '') + 'Breakdown:';
          clientStepData.fees_arr.map((fee_data: any) => {
            fees += (fees ? '<br>' : '') + fee_data.fee_type + ':'
            if (fee_data.amount) fees += (fees ? ' ' : '') + fee_data.amount + ' PHP'
          })
        }
      } //fees += clientStepData.fees+' php'//return clientStepData.fees+' php'
      else if (clientStepData.list_of_possible_fees_or_formulas == true && clientStepData.list_of_fees_arr && clientStepData.list_of_fees_arr.length > 0) {
        clientStepData.list_of_fees_arr.map((list_of_fees_data: any) => {
          fees += (fees ? '<br><br>' : '') + list_of_fees_data.fee_type + ':'
          if (list_of_fees_data.list_fee_desc) fees += (fees ? '<br>' : '') + list_of_fees_data.list_fee_desc
        })
      }//fees += (fees ? '<br>' : '')+clientStepData.list_of_fees_val//return clientStepData.list_of_fees_val

      return fees
    }
    // else if(clientStepData.is_situational_step) return clientStepData.fees+' php'
    return 'None'
  }

  scrollTo(serviceId: any) {
    if (serviceId) {
      let element = document.getElementById(serviceId)
      if (element) element.scrollIntoView({ behavior: 'auto', block: "center" });
    }
  }

  changeEmitter(code: string, value: any) {
    switch (code) {
      case 'cart': {
        const cart = {
          headOfAgency: this.headOfAgency,
          chairPerson: this.chairPerson,
          viceChairPerson: this.viceChairPerson,
          member: this.member
        }
        this.changeDetect.emit({ code: code, value: cart });
        break;
      }
      default: this.changeDetect.emit({ code: code, value: value }); break;
    }
  }

  updateLinkTrigger(value: any) {
    // if(!this.currentCC.reportURL)
    // console.log('changing cc reportURL: ',value)
    this.currentCC.reportURL = value
  }
}